import { Icon } from '@chakra-ui/react';
import { MdFullscreen, MdFullscreenExit } from 'react-icons/md';
import { IconButton } from 'components';

interface Props {
  isOpen: boolean;
  onClick(): void;
}

export const ExpandControl = (props: Props) => {
  const { isOpen, onClick } = props;

  const onClickExpandOrShrink = () => {
    onClick();
  };

  return (
    <IconButton
      aria-label="Expand/Shrink map"
      onClick={onClickExpandOrShrink}
      position="absolute"
      right="10px"
      top="7rem"
      bg="white"
      py={0}
      px={0}
      w="29px"
      h="28px"
      size="xs"
      rounded="4px"
      zIndex={2}
      whileHover={{}}
      whileTap={{}}
    >
      <Icon
        as={isOpen ? MdFullscreenExit : MdFullscreen}
        fontSize="1.75rem"
        color="blue.800"
      />
    </IconButton>
  );
};
